import { Field, useFormikContext } from "formik";
import EmailIcon from "../../assets/icons/alert-management-icons/email-icon";
import PushNotificationIcon from "../../assets/icons/alert-management-icons/push-notification-icon";
import SmsIcon from "../../assets/icons/alert-management-icons/sms-icon";
import WhatsappIcon from "../../assets/icons/alert-management-icons/whatsapp-icon";
import CheckBox from "../forms/check-box-field";

function Communications({ type, input, index, disabled }) {
  const { setFieldValue } = useFormikContext();
  let icon = null;
  let input2

  if (type === "Email") {
    icon = <EmailIcon />;
    input2="email"
  } else if (type === "Sms") {
    icon = <SmsIcon />;
    input2="sms"
  } else if (type === "Whatsapp") {
    icon = <WhatsappIcon />;
    input2="whatsapp"
  } else if (type === "Push Notification") {
    icon = <PushNotificationIcon />;
    input2="push_notification"
  }

  return (
    <div className="flex flex-row w-full items-center gap-2 p-3 rounded-lg  border border-[var(--alert-management-border-color)]">
      <Field name={`notificationData.${input}`}>
        {({ field }) => (
          <input
            type="checkbox"
            {...field}
            checked={field.value || false}
            onChange={(e) => {
              setFieldValue(`notificationData.${input}`, e.target.checked);
              setFieldValue(
                `notificationCommunicationData[${index}].${input}`,
                e.target.checked
              );
              setFieldValue(`notificationRecipientsData.${input2}.required`,e.target.checked)

            }}
            disabled={disabled}
            className="custom-checkbox form-check-input ml-[3px]"
          />
        )}
      </Field>
      {icon}
      <label
        className={
          "text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]"
        }
      >
        {type}
      </label>
    </div>
  );
}

export default Communications;
